export const getTrackInstructors = (track) => {
  const rawList = Array.isArray(track?.instructors) && track.instructors.length
    ? track.instructors
    : track?.instructor
      ? [track.instructor]
      : [];

  return rawList.filter(Boolean);
};

export const getTrackPrimaryInstructor = (track) => getTrackInstructors(track)[0] || null;

export const getTrackInstructorIds = (track) =>
  getTrackInstructors(track)
    .map((instructor) => instructor?._id || instructor?.id || instructor)
    .filter(Boolean)
    .map((id) => `${id}`);

export const getTrackInstructorNames = (track) =>
  getTrackInstructors(track)
    .map((instructor) => instructor?.fullName || instructor?.name || "")
    .filter(Boolean);

export const isTrackOwnedByUser = (track, userId) =>
  Boolean(userId && getTrackInstructorIds(track).includes(`${userId}`));
